import { Form } from 'antd'

export function mapPropsToFields({ initialValues = {} }) {
  const objectValues = {}
  Object.keys(initialValues).forEach(key => {
    objectValues[key] = Form.createFormField({ value: initialValues[key] })
  })
  return objectValues
}

export function copyTextToClipboard(text, message) {
  const input = document.createElement('textarea')

  input.style.position = 'fixed'
  input.style.top = 0
  input.style.left = 0

  input.style.width = '2em'
  input.style.height = '2em'
  input.style.padding = 0
  input.style.border = 'none'
  input.style.outline = 'none'
  input.style.boxShadow = 'none'
  input.style.background = 'transparent'

  input.value = text

  document.body.appendChild(input)
  input.focus()
  input.select()

  try {
    document.execCommand('copy')
    document.body.removeChild(input)
  } catch (err) {
    console.log('Oops, unable to copy')
    return false
  }

}



// WEBPACK FOOTER //
// ./src/utils/form.js